import { render, staticRenderFns } from "./StatusIQCustomization.vue?vue&type=template&id=cf5b3aee&scoped=true"
import script from "./StatusIQCustomization.vue?vue&type=script&lang=js"
export * from "./StatusIQCustomization.vue?vue&type=script&lang=js"
import style0 from "./StatusIQCustomization.vue?vue&type=style&index=0&id=cf5b3aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5b3aee",
  null
  
)

export default component.exports